module.exports = "/_next/static/images/muskein-4ad8be7081933fa3ebcf1d908a42790e.png";